import Vue from "vue"
import {
    dateFormat
} from './index'

Vue.filter("dateFormat",function(value,fmt){
    if(!value) return "";
    return dateFormat(value,fmt);
})